import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from './useUniversalNavContext';
export const prepareAccountData = (json) => {
    const account = json;
    const plan = account.plan_info;
    const output = {
        id: account.id,
        name: account.name,
        currency: account.currency,
        plan: {
            amount: plan.amount,
            hasMeteredBilling: plan.metered_task_pricing,
            id: plan.id,
            name: plan.name,
            interval: plan.interval,
            allowTeams: plan.allow_teams,
        },
        isTrialing: account.is_trialing,
        trialEndDate: account.trial_end_date,
        isTrialingTeams: account.is_trialing_teams,
        teamTrialEndDate: account.teams_trial_end_date,
        teamsTrialAutoUpgrade: account.teams_trial_auto_upgrade,
        isTrialingCompanies: account.is_trialing_companies,
        companiesTrialEndDate: account.companies_trial_end_date,
        companiesTrialAutoUpgrade: account.companies_trial_auto_upgrade,
        isTrialingEnterprise: account.is_trialing_enterprise,
        enterpriseTrialEndDate: account.enterprise_trial_end_date,
        isTeamAccount: account.is_team_account,
        teamAccountEndDate: account.team_account_end_date,
        isCompanyAccount: account.is_company_account,
        isUnlimited: account.is_unlimited,
        isEnterpriseAccount: account.is_enterprise_account,
        enterpriseAccountEndDate: account.enterprise_account_end_date,
        firstKnownUpgradeDate: account.first_known_upgrade_date,
        hasOverdueInvoice: account.has_overdue_invoice,
        taskBufferOverride: account.task_buffer_override,
        paysManually: account.pays_manually,
        subscriptionRenewalDate: account.subscription_renewal_date,
        isWorkspace: account.parent_account_relationship === 'workspace',
    };
    return output;
};
export const useQueryAccount = ({ apiHostname: apiHostnameFromParams, currentAccountId, }) => {
    const { accountData: accountDataFromProps, apiHostname: apiHostnameFromContext, } = useUniversalNavContext();
    const apiHostname = apiHostnameFromParams || apiHostnameFromContext;
    const result = useQuery({
        queryKey: ['account', currentAccountId],
        queryFn: async () => {
            if (!currentAccountId)
                throw new Error('No currentAccountId specified.');
            const response = await fetch(`${apiHostname}/api/v4/accounts/${encodeURIComponent(currentAccountId)}`, {
                credentials: process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const json = await response.json();
            return json;
        },
        select: prepareAccountData,
        enabled: !accountDataFromProps && !!currentAccountId,
        initialData: accountDataFromProps,
    });
    return Object.assign(Object.assign({}, result), { isLoading: result.isInitialLoading });
};
//# sourceMappingURL=useQueryAccount.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
